import * as React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Stack,
  Chip,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import { CON_DEFAULT_IMG, CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { FormatDate } from "../../utils/common/DateUtils";
import { GRN_API_10, GRN_API_12 } from "../../api/ApiModel";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { externalgetApi } from "../../services/externalApis";
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import CheckIcon from "@mui/icons-material/Check";
import DescriptionIcon from '@mui/icons-material/Description';
import { AnyForNow } from "../../features/grn/types";

import { ITEM_LABELS } from "../../utils/sys/GrnLabels";

interface GrnStatusHistoryProps {
  trackingDetails: AnyForNow;
  grncode: string;
}

const GrnStatusHistory: React.FC<GrnStatusHistoryProps> = (props) => {
  const { trackingDetails, grncode } = props;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [grnStatusTypes, serGrnStatusTypes] = useState<AnyForNow[]>([]);

  useEffect(() => {
    fetchGrnStatusTypes();
  }, []);
  const fetchGrnStatusTypes = async () => {
    try {
      const result = await externalgetApi(GRN_API_12, "GET", {
        STS: CON_STATUS_ACTIVE,
      });
      // console.log("fetchGrnStatusTypes", result);
      if (Array.isArray(result)) {
        serGrnStatusTypes(result);
      }
    } catch (err) {
      console.error("Error fetching GRN status types:", err);
    }
  };

  return (
    <Box sx={{}}>
      <Paper sx={{ p: 1, mb: 8 }}>
        <Typography variant={"subtitle_m" as any} color="primary" gutterBottom>
          GRN ID {grncode}
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Stack spacing={2}>
          {trackingDetails.map((track, index) => {
            const statusInfo = grnStatusTypes.find(
              (status) => status.trsts === track.trsts
            );
            console.log("statusInfo", statusInfo);
            const isLast = index === trackingDetails.length - 1;
            return (
              <Box
                key={index}
                sx={{
                  // display: "flex",
                  // flexDirection: { xs: "column", sm: "column" },

                  // alignItems: "flex-start",
                  // gap: 1,
                  // py: 1,
                  position: "relative",
                }}
              >
                {/* Connector Line */}
                {/* {!isLast && ( */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 20,
                    left: 6,
                    width: "2px",
                    height: "100%",
                    bgcolor: "grey.300",
                    zIndex: 0,
                  }}
                />
                {/* )} */}

                {/* Timeline Dot */}
                <Box
                  sx={{
                    position: "absolute",
                    // bottom: -10,
                    top: 24,

                    left: -4,
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    color: "white",
                    bgcolor:
                      statusInfo?.colorcode || theme.palette.primary.main,
                    border: "2px solid white",
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckIcon sx={{ fontSize: "12px" }} />
                </Box>
                <Paper
                  elevation={1}
                  sx={{
                    px: 2,
                    pt: 3,
                    pb: 1,
                    pl: 3,
                    borderBottom: `1px solid ${(theme.palette as any).greyscale.stroke_1}`,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between", // space between left and right items
                      alignItems: "center", // vertical alignment
                      width: "100%",
                      mb: 1,
                    }}
                  >
                    <Chip
                      label={statusInfo?.trenuserremark || "UNKNOWN"}
                      size="small"
                      sx={{
                        // px: 1,
                        backgroundColor:
                          statusInfo?.colorcode || theme.palette.grey[300],
                        color: "#fff",
                      }}
                    />
                    <Typography
                      variant="subtitle_s"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Tooltip title={"Date"} arrow placement="bottom">
                        <CalendarMonthOutlinedIcon
                          sx={{
                            fontSize: "20px",
                          }}
                        />
                      </Tooltip>
                      {FormatDate(track.endate)}
                    </Typography>{" "}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant="body_xs"
                      color="text.secondary"
                      sx={{
                        whiteSpace: "nowrap",

                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Tooltip title={"User"} arrow placement="bottom">
                        <PersonOutlineOutlinedIcon
                          sx={{
                            fontSize: "20px",
                          }}
                        />
                      </Tooltip>
                      {track.enuser}
                    </Typography>
                    <Typography
                      variant="body_xs"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        overflow: "hidden", // required for ellipsis
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                    >
                      <Tooltip title={ITEM_LABELS.REASON} arrow placement="bottom">
                        <NotesOutlinedIcon
                          sx={{
                            fontSize: "16px",
                          }}
                        />
                      </Tooltip>

                      {/* <strong>Reason :</strong> */}
                      <Tooltip
                        title={track.reason || ""}
                        arrow
                        placement="bottom"
                      >
                        {track.reason|| "No Reason"}
                      </Tooltip>
                    </Typography>
                     <Typography
                      variant="body_xs"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        overflow: "hidden", // required for ellipsis
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                    >
                      <Tooltip title={ITEM_LABELS.REMARK} arrow placement="bottom">
                        <DescriptionIcon
                          sx={{
                            fontSize: "16px",
                          }}
                        />
                      </Tooltip>

                      {/* <strong>Reason :</strong> */}
                      <Tooltip
                        title={track.remark || ""}
                        arrow
                        placement="bottom"
                      >
                        {track.remark|| "No Remark"}
                      </Tooltip>
                    </Typography>
{(() => {
  try {
    if (!track.docpaths) return null; // No data — don't render

    const parsed = JSON.parse(track.docpaths);
    if (!Array.isArray(parsed) || parsed.length === 0) return null;

    const filePath = parsed[0]?.FILEPATH || "";
    const docTypeCode = parsed[0]?.DOCTYPECODE || "";

    // 🧩 If default image path → Show "No Attachment"
    if (
      filePath === CON_DEFAULT_IMG ||
      filePath === CON_DEFAULT_IMG ||
      filePath.includes("noimage.png")
    ) {
      return (
        <Typography
          variant="body_xs"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title="Attachment" arrow placement="bottom">
            <CreateNewFolderIcon
              sx={{ fontSize: 16 }}
            />
          </Tooltip>
          No Attachment
        </Typography>
      );
    }

    //  Show attachment link only for DOCTYPECODE = "0" and valid path (not noimage.png)
    if (docTypeCode === "0" && filePath && !filePath.includes("noimage.png")) {
      return (
        <Typography
          variant="body_xs"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          <Tooltip title="Attachment" arrow placement="bottom">
            <CreateNewFolderIcon sx={{ fontSize: 16 }} />
          </Tooltip>
          <a
            href={filePath}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: theme.palette.primary.main,
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <SimCardDownloadIcon sx={{ fontSize: 16 }} />
          </a>
        </Typography>
      );
    }

    // Show "No Attachment" if DOCTYPECODE = "0" but filePath is empty or noimage.png
    if (docTypeCode === "0" && (!filePath || filePath.includes("noimage.png"))) {
      return (
        <Typography
          variant="body_xs"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title="Attachment" arrow placement="bottom">
            <CreateNewFolderIcon
              sx={{ fontSize: 16 }}
            />
          </Tooltip>
          No Attachment
        </Typography>
      );
    }

    // 🗂️ Show "No Attachment" if DOCTYPECODE is empty string
    if (docTypeCode === "") {
      return (
        <Typography
          variant="body_xs"
          color="text.secondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title="Attachment" arrow placement="bottom">
            <CreateNewFolderIcon
              sx={{ fontSize: 16 }}
            />
          </Tooltip>
          No Attachment
        </Typography>
      );
    }
  } catch (err) {
    console.error("Invalid JSON in docpaths:", track.docpaths, err);
  }

  return null; // hide for all other cases
})()}

                  </Box>
                  {/* <Typography
                variant="body_xs"
                color="text.secondary"
                sx={{
                  whiteSpace: "nowrap",

                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <NotesOutlinedIcon
                  sx={{
                    fontSize: "16px",
                    // fontSize: "8px",
                  }}
                /> */}
                  {/* <strong>Remark :</strong> {remarkDescription} */}
                  {/* </Typography> */}

                  {/* <Box display="flex" justifyContent="flex-start" gap={2} mt={0}>
                  {attachments.map((_, index) => (
                    <Box key={index} display="flex" alignItems="center">
                      <img
                        src="https://storage.googleapis.com/a1aa/image/WH4WISht5NgaU0irk16xVrMvQ8nCTgi2WMTpNiggp3s.jpg"
                        alt="PDF icon"
                        style={{ width: "32px", height: "32px" }}
                      />
                    </Box>
                  ))}
                </Box> */}
                </Paper>
              </Box>
            );
          })}
        </Stack>
      </Paper>
    </Box>
  );
};

export default GrnStatusHistory;
